import { createApiUrl } from '../../Config/apiConfig';

export const TABLE_COLUMNS = [
    { field: "OperatorName", headerName: "Operator Name", flex: 1, minWidth: 150 },
    { field: "ServerName", headerName: "Server Name", flex: 2, minWidth: 200 },
    { field: "LobbyName", headerName: "Lobby Name", flex: 1, minWidth: 150 },
    { field: "ServerID", headerName: "Server ID", flex: 1, minWidth: 100 },
    { field: "OperatorID", headerName: "Operator ID", flex: 1, minWidth: 100 },
    { field: "IntegrationType", headerName: "Integration Type", flex: 1, minWidth: 150 },
    { field: "CasinoSiteID", headerName: "Casino Site ID", flex: 1, minWidth: 120 },
    { field: "MarketCode", headerName: "Market Code", flex: 1, minWidth: 100 },
    {
        field: "details",
        headerName: "Details",
        flex: 0.5,
        minWidth: 120,
        renderCell: (params) => (
            <button className="data-grid-button" onClick={() => params.row.onViewDetails(params.row)}>
                View Details
            </button>
        ),
    },
];

export const INTEGRATION_TYPES = {
    GAMEFLEX: "GameFlex",
    OGS: "OGS",
    GGI: "GGI"
};

export const API_ENDPOINTS = {
    SERVER_DETAILS: createApiUrl('CoreflexData/fetch')
};